import { MiddlewareArray } from '@reduxjs/toolkit'
import { Reducer, Store } from 'redux'

import siteBuilderReducer from 'core-components/sitebuilder/store/siteBuilderSlice'
import { setSiteBuilderAppStore } from 'src/core/sitebuilder/store'
import { IAppStore } from 'src/core/components/app/models/IAppStore'
import { initStore } from 'src/core/store'

export const createAppStore = (
  storeReducer: IAppStore['storeReducer'],
  storeMiddleware: IAppStore['storeMiddleware'],
  loadedReducers: { [key: string]: Reducer },
  loadedMiddlewares: MiddlewareArray<any>,
  loadedStoreSetters: ((store: Store) => void)[],
  setApplicationStore: IAppStore['setApplicationStore'],
  devTools: IAppStore['devTools']
): Store => {
  const store = initStore(
    { siteBuilder: siteBuilderReducer, ...storeReducer, ...loadedReducers },
    { middleware: storeMiddleware, loadedMiddlewares, devTools }
  )

  setApplicationStore?.(store)
  loadedStoreSetters.forEach((setter) => setter(store))
  setSiteBuilderAppStore(store)

  return store
}
